export default __webpack_public_path__ + "fr/static/media/logo-avis-verifies-mobile-uk.9cc5b66a.png";